// extracted by mini-css-extract-plugin
module.exports = {"cancel":"RgIBnuG8lJyUkAFKTSPru"};